import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import {
    Box,
    IconButton,
    ListItemIcon,
    ListItemText,
    Menu,
    MenuItem,
    Stack,
    type Theme,
    Typography,
} from '@mui/material';
import NOLItemList from '/@/components/new-overlay-list/item-list';
import { useAnchorEl } from '/@/hooks/anchor-el/useAnchorEl';
import { _ } from '/@/locale';
import type { Field } from '/@/types/field';

type overlayConfig = {
    id: string;
    name: string;
    icon: string;
    color: string;
    enable: boolean;
};

const FieldOptions = ({
    filteredOverlayConfig,
    selectedField,
    userTypeView = 'user',
    selectItem,
    handleConfirmDelete,
    edit,
    setEdit,
}: {
    filteredOverlayConfig: overlayConfig[];
    selectedField: Field;
    userTypeView: 'rv' | 'user';
    selectItem: (item: overlayConfig, e: React.MouseEvent<HTMLButtonElement>) => void;
    handleConfirmDelete: () => void;
    edit: boolean;
    setEdit: (edit: boolean) => void;
}) => {
    const [{ open, anchorEl }, { handleClick, handleClose }] = useAnchorEl();

    return (
        <Box
            sx={{
                height: { xs: '100%', md: userTypeView !== 'rv' ? undefined : '600px' },
            }}
        >
            <Stack
                direction='row'
                justifyContent='space-between'
                alignItems='center'
                sx={{ p: 2, borderBottom: (t: Theme) => `1px solid ${t.palette.divider}` }}
            >
                <Typography sx={{ overflowWrap: 'anywhere' }}>{selectedField.name}</Typography>
                <IconButton
                    onClick={(ev: React.MouseEvent<HTMLButtonElement>) => {
                        if (!edit) handleClick(ev);
                    }}
                >
                    <MoreVertIcon sx={{ fontSize: 20 }} />
                </IconButton>
                <Menu
                    id='demo-positioned-menu'
                    aria-labelledby='demo-positioned-button'
                    anchorEl={anchorEl}
                    open={open}
                    onClose={handleClose}
                    anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'left',
                    }}
                    transformOrigin={{
                        vertical: 'top',
                        horizontal: 'left',
                    }}
                >
                    <MenuItem
                        onClick={() => {
                            setEdit(true);
                            handleClose();
                        }}
                    >
                        <ListItemIcon>
                            <EditIcon
                                sx={{
                                    color: (t: Theme) => t.palette.grey[500],
                                }}
                            />
                        </ListItemIcon>
                        <ListItemText>{_('Editar')}</ListItemText>
                    </MenuItem>
                    <MenuItem
                        onClick={() => {
                            handleConfirmDelete();
                            handleClose();
                        }}
                    >
                        <ListItemIcon>
                            <DeleteIcon
                                sx={{
                                    color: (t: Theme) => t.palette.grey[500],
                                }}
                            />
                        </ListItemIcon>
                        <ListItemText>{_('Eliminar')}</ListItemText>
                    </MenuItem>
                </Menu>
            </Stack>
            <NOLItemList
                selectItem={(item: overlayConfig, e: React.MouseEvent<HTMLButtonElement>) => {
                    selectItem(item, e);
                }}
                itemList={filteredOverlayConfig}
                fieldId={selectedField.id}
            />
        </Box>
    );
};

export default FieldOptions;
